import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";
import { observer } from "mobx-react";
import numeral from "numeral";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ResultLevelCardSectionSparkLineChart from "../components/ResultLevelCardSectionSparkLineChart";
import ResultLevelCardBillRateDetailsTable from "../components/ResultLevelCardBillRateDetailsTable";
import { LEVEL_SELECTOR, VALUE_CHANGE_COLOR } from "../../../constants/css";
import { shouldShowCurrency, getCurrency } from "../components/SupportFunctions";
import { CONTINGENT_RATE_TYPE } from "../../ratecards/components/RateDisplayToggle";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

class ResultLevelCardBillRateSection extends React.Component {
  _handleShowRateTrend = () => {
    const store = this.props.store;
    store.onShowRatesTrend(
      this.props.resultLevel.levelName,
      store.selectedSampleSize.value
    );
  };

  render() {
    const props = this.props;
    let store = props.store;
    let resultLevel = props.resultLevel;
    let months = props.months;
    let ratesHistoryData = props.ratesHistoryData;
    let ratesMissingData = props.ratesMissingData;
    let changesHistoryData = props.changesHistoryData;
    let changesMissingData = props.changesMissingData;

    let levelSelector = LEVEL_SELECTOR[resultLevel.levelName];
    let color = "#FFFFFF";
    let positiveColor = VALUE_CHANGE_COLOR[resultLevel.levelName].positive;
    let negativeColor = VALUE_CHANGE_COLOR[resultLevel.levelName].negative;

    let currencySymbol = "";
    let showCurrency = shouldShowCurrency(resultLevel);
    if (showCurrency) currencySymbol = props.currency || getCurrency(store.search);
    const rateMultiplier = props.rateMultiplier || 1;
    const contingentRateFrequency = props.contingentRateFrequency;

    let contingent_label = "per hour";
    if (contingentRateFrequency === CONTINGENT_RATE_TYPE.DAILY) {
      contingent_label = "per day";
    } else if (contingentRateFrequency === CONTINGENT_RATE_TYPE.WEEKLY) {
      contingent_label = "per week";
    } else if (contingentRateFrequency === CONTINGENT_RATE_TYPE.MONTHLY) {
      contingent_label = "per month";
    }

    return (
      <div
        className={classNames("row", "bill-info", levelSelector, {
          hidden: store.hideBillRate,
        })}
      >
        <div className="col-xs-12">
          <table className="table level-data bill-info">
            <thead>
              <tr>
                <th>
                  Max Bill Rate{" "}
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="billRateTooltip">
                        Bill Rates include all costs except VAT or GST tax.
                      </Tooltip>
                    }
                  >
                    <FontAwesomeIcon icon="info-circle" style={{ marginLeft: 5 }} />
                  </OverlayTrigger>
                </th>
                <th
                  colSpan="3"
                  className="text-right"
                  onClick={this._handleShowRateTrend}
                  style={{ cursor: "pointer" }}
                >
                  {!props.hideSparkLine && (
                    <ResultLevelCardSectionSparkLineChart
                      store={store}
                      months={months}
                      ratesHistoryData={ratesHistoryData}
                      ratesMissingData={ratesMissingData}
                      changesHistoryData={changesHistoryData}
                      changesMissingData={changesMissingData}
                      currencySymbol={currencySymbol}
                      seriesColor={color}
                      positiveColor={positiveColor}
                      negativeColor={negativeColor}
                      rateMultiplier={rateMultiplier}
                    />
                  )}
                </th>
              </tr>
            </thead>
            <tbody className="text-muted">
              <tr>
                <td className="max-value">
                  <div className="max-value-wrapper">
                    <header>
                      <h4>
                        {currencySymbol}{" "}
                        {numeral(resultLevel.billRateMax * rateMultiplier).format(
                          "0,0.00"
                        )}
                      </h4>
                      <h5 className="unit">Max Bill Rate</h5>
                    </header>
                    <div className="caption">{contingent_label}</div>
                  </div>
                </td>
                <td colSpan="3" className="no-padding">
                  <ResultLevelCardBillRateDetailsTable
                    store={store}
                    resultLevel={resultLevel}
                    currency={currencySymbol}
                    rateMultiplier={rateMultiplier}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

ResultLevelCardBillRateSection.propTypes = {
  store: PropTypes.object.isRequired,
  resultLevel: PropTypes.object.isRequired,
  currency: PropTypes.string,
  months: PropTypes.array.isRequired,
  ratesHistoryData: PropTypes.array.isRequired,
  ratesMissingData: PropTypes.array.isRequired,
  changesHistoryData: PropTypes.array.isRequired,
  changesMissingData: PropTypes.array.isRequired,
  hideSparkLine: PropTypes.bool,
  rateMultiplier: PropTypes.number,
  contingentRateFrequency: PropTypes.string,
};
ResultLevelCardBillRateSection.defaultProps = {
  hideSparkLine: false,
};

export default observer(ResultLevelCardBillRateSection);
